import React from 'react';

// only show the increment menu if there are hidden items
import { translate } from '~l10n/client';

import { SmallButton } from '~shared/components/buttons';
import { Container } from '~shared/components/Container';

interface Props {
  maxRows: number;
  setMaxRows: () => void;
  totalRows: number;
}

export function WorkspaceItemIncrementMenu({
  maxRows,
  setMaxRows,
  totalRows,
}: Props) {
  if (totalRows <= maxRows) {
    return null;
  }
  return (
    <Container verticalCenter horizontalCenter className={'p-4'}>
      <SmallButton appearance={'default'} onClick={setMaxRows}>
        {translate('Load More')}
      </SmallButton>
    </Container>
  );
}
